/**
 * @generated SignedSource<<dd297e59e63f29c747780a3e40b078ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SiteNavItem_navigationModule$data = {
  readonly isHighlighted: boolean | null;
  readonly items: ReadonlyArray<{
    readonly name: string | null;
  } | null> | null;
  readonly linkData: {
    readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
  };
  readonly name: string | null;
  readonly " $fragmentType": "SiteNavItem_navigationModule";
};
export type SiteNavItem_navigationModule$key = {
  readonly " $data"?: SiteNavItem_navigationModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"SiteNavItem_navigationModule">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SiteNavItem_navigationModule",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isHighlighted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NavigationTopLevel",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "NavigationModule",
  "abstractKey": null
};
})();

(node as any).hash = "6a0afb523964dcd03760067c272da83f";

export default node;
